// extracted by mini-css-extract-plugin
export default {"header":"Header_header__-mcTL","logo":"Header_logo__gshF0","logoIcon":"Header_logoIcon__29FQg","logoTitle":"Header_logoTitle__2g3CN","logoSubtitle":"Header_logoSubtitle__D5z2Y"};